import { Routes, Route } from 'react-router-dom';

import MapView from './Mapview';
import ARView from './ARview';
import SplashScreen from './components/withSplashScreen';

const App = () => {
    document.addEventListener('keydown', function(event) {
    const key = event.key; // const {key} = event; ES6+
    if (key === "Backspace" || key === "Delete") {
        return false;
    }
});

  return (
   
      <Routes>
        <Route exact path='/*' element={<SplashScreen />}></Route>
        <Route exact path='/nearby' element={<MapView />}></Route>
        <Route exact path='/ar' element={<ARView />}></Route>
      </Routes>
  );
}

export default App;

